"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6508],{

/***/ 13493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareButton; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/IconsSvg/ShareIcon.jsx

function ShareIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z",
            fill: "#808285"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/jss/Home.styles.js
var Home_styles = __webpack_require__(47728);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(51813);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/ShareButton.jsx





function ShareButton(param) {
    var newsUrl = param.newsUrl;
    var ref = (0,react.useState)(false), showPopup = ref[0], setShowPopup = ref[1];
    var t = (0,esm/* useTranslation */.$G)([
        "article"
    ]).t;
    var togglePopup = function() {
        setShowPopup(!showPopup);
    };
    var copyToClipboard = function() {
        navigator.clipboard.writeText(newsUrl).then(function() {
            alert(t("news.link-copied"));
        }).catch(function(err) {
            console.error("Failed to copy: ", err);
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Home_styles/* ShareDiv */._t, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "date",
                onClick: togglePopup,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareIcon, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: t("news.share")
                    })
                ]
            }),
            showPopup && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Home_styles/* ShareLinkPopup */.dl, {
                className: "share-popup",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "share-popup",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                            className: "copy-instruction",
                            children: t("news.copy-link")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "url-box",
                            onClick: copyToClipboard,
                            children: newsUrl
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            onClick: togglePopup,
                            className: "close-button",
                            children: "X"
                        })
                    ]
                })
            })
        ]
    });
};
;


/***/ }),

/***/ 76508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oU": function() { return /* reexport */ ArticleItems; },
  "mZ": function() { return /* reexport */ AsideArchive; },
  "rk": function() { return /* reexport */ AsideNews; },
  "DU": function() { return /* reexport */ BigNewsSection; },
  "o0": function() { return /* reexport */ GallerySection; },
  "ze": function() { return /* reexport */ NTContainer; },
  "i3": function() { return /* reexport */ NewsListPageHeader; },
  "ZG": function() { return /* reexport */ RandomNews; },
  "Ce": function() { return /* reexport */ TendersItems; }
});

// UNUSED EXPORTS: ShareButton

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./styles/jss/News.styles.js
var News_styles = __webpack_require__(5913);
// EXTERNAL MODULE: ./components/DateStamp.jsx
var DateStamp = __webpack_require__(89411);
// EXTERNAL MODULE: ./utils/helperFunction.js
var helperFunction = __webpack_require__(18991);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(51813);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/HeadTitle.jsx





function HeadTitle(_param) {
    var children = _param.children, as = _param.as, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "as"
    ]);
    var locale = (0,router.useRouter)().locale;
    var Component = as || "h2";
    var Fancy = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Component, {
        target: "euyuv270",
        label: "Fancy"
    })("font-weight:500;font-size:18px;line-height:31px;color:", function(param) {
        var theme = param.theme;
        return theme.palette.primary.main;
    }, ";");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: props.url,
        locale: locale,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Fancy, {
                className: props.className || "title",
                children: children
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/AsideNews.jsx






function AsideNews(param) {
    var news = param.news;
    var t = (0,esm/* useTranslation */.$G)([
        "article"
    ]).t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(News_styles/* Aside */.xN, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                className: "title",
                children: t("news.latest")
            }),
            news.map(function(param) {
                var id = param.id, attributes = param.attributes;
                var title = attributes.title, slug = attributes.slug, datetime = attributes.datetime;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(News_styles/* NewsListItem */.nB, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeadTitle, {
                            as: "p",
                            url: "/media-center/news/".concat(id, "/").concat(slug),
                            className: "content",
                            children: (0,helperFunction/* truncateString */.aS)(title, 100)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateStamp/* default */.Z, {
                            date: datetime,
                            time: true
                        })
                    ]
                }, id);
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/NextImage.jsx
var NextImage = __webpack_require__(68164);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/ArticleItems.jsx






function ArticleItems(news) {
    var ref, ref1, ref2, ref3;
    var id = news.id, date = news.date, _attributes = news.attributes, title = _attributes.title, slug = _attributes.slug, thumbnail = _attributes.thumbnail, short_description = _attributes.short_description, datetime = _attributes.datetime, time = _attributes.time;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(News_styles/* ArticleItem */.oF, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "imageWrapper",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextImage/* default */.Z, {
                    layout: "responsive",
                    width: 180,
                    height: 150,
                    objectFit: "cover",
                    src: (ref = thumbnail.data) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.formats) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.url,
                    alt: title,
                    placeholder: "blur"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "contentWrapper",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeadTitle, {
                        as: "h2",
                        url: "/media-center/news/".concat(id, "/").concat(slug),
                        children: (0,helperFunction/* truncateString */.aS)(title, 300)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        className: "text",
                        children: (0,helperFunction/* truncateString */.aS)(short_description, 135)
                    }),
                    date && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateStamp/* default */.Z, {
                        date: datetime,
                        time: time
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./styles/jss/Layout.styles.js
var Layout_styles = __webpack_require__(48231);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/BigNewsSection.jsx







function BigNewsSection(news) {
    var ref, ref1;
    var id = news.id, _attributes = news.attributes, slug = _attributes.slug, title = _attributes.title, thumbnail = _attributes.thumbnail, short_description = _attributes.short_description, datetime = _attributes.datetime;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(News_styles/* BigNews */.dI, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "imageWrapper",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextImage/* default */.Z, {
                    layout: "fill",
                    objectFit: "cover",
                    src: (ref1 = (0,helperFunction/* getImageUrl */.Jn)((ref = thumbnail.data) === null || ref === void 0 ? void 0 : ref.attributes.formats, [
                        "large",
                        "medium"
                    ])) === null || ref1 === void 0 ? void 0 : ref1.url,
                    alt: title,
                    placeholder: "blur"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "contentWrapper",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeadTitle, {
                        as: "h1",
                        url: "/media-center/news/".concat(id, "/").concat(slug),
                        children: (0,helperFunction/* truncateString */.aS)(title, 250)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles/* ShortDescription */.bS, {
                        className: "text",
                        children: (0,helperFunction/* truncateString */.aS)(short_description, 450)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateStamp/* default */.Z, {
                        date: datetime,
                        time: true
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./components/IconsSvg/index.jsx + 80 modules
var IconsSvg = __webpack_require__(765);
// EXTERNAL MODULE: ./services/api.js
var api = __webpack_require__(35559);
// EXTERNAL MODULE: ./services/qsStringify.js
var qsStringify = __webpack_require__(55063);
;// CONCATENATED MODULE: ./services/archive.api.js


var getArchiveList = function(locale, url) {
    var query = (0,qsStringify/* default */.Z)({
        locale: locale,
        pagination: {
            page: 1,
            pageSize: 1000
        }
    });
    var endpoint = url.includes("tender") ? "/api-tenders-archives" : "/api-archives";
    return api/* default.get */.Z.get("".concat(endpoint, "?").concat(query)).then(function(res) {
        return res.data;
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/AsideArchive.jsx















function AsideArchive(param) {
    var title = param.title, url = param.url;
    var ref;
    var ref1 = (0,router.useRouter)(), locale = ref1.locale, query = ref1.query;
    var t = (0,esm/* useTranslation */.$G)([
        "article"
    ]).t;
    var ref2 = (0,useQuery/* useQuery */.a)([
        "archive-list",
        locale
    ], function() {
        return getArchiveList(locale, url);
    }, {
        staleTime: 0,
        cacheTime: Infinity,
        select: function(data) {
            var handle_orderMonth = function(date) {
                var conditionValue = date.trim().toLowerCase();
                if (locale === "fa") {
                    switch(conditionValue){
                        case "فروردین":
                            return 1;
                        case "اردیبهشت":
                            return 2;
                        case "خرداد":
                            return 3;
                        case "تیر":
                            return 4;
                        case "مرداد":
                            return 5;
                        case "شهریور":
                            return 6;
                        case "مهر":
                            return 7;
                        case "آبان":
                            return 8;
                        case "آذر":
                            return 9;
                        case "دی":
                            return 10;
                        case "بهمن":
                            return 11;
                        case "اسفند":
                            return 12;
                    }
                } else {
                    switch(conditionValue){
                        case "april":
                            return 1;
                        case "may":
                            return 2;
                        case "june":
                            return 3;
                        case "july":
                            return 4;
                        case "august":
                            return 5;
                        case "september":
                            return 6;
                        case "october":
                            return 7;
                        case "november":
                            return 8;
                        case "december":
                            return 9;
                        case "january":
                            return 10;
                        case "february":
                            return 11;
                        case "march":
                            return 12;
                    }
                }
            };
            var res = data.data.reduce(function(newArr, arr) {
                var key = arr.attributes.slug.toString().split("-")[1];
                var date = arr.attributes.date.toString().trim().split(" ")[0];
                var newArrayKeys = newArr.map(function(item) {
                    return Object.keys(item);
                }).flat();
                if (!newArrayKeys.includes(key)) {
                    newArr.push((0,_define_property/* default */.Z)({}, key, new Array({
                        month_id: handle_orderMonth(date),
                        date: date,
                        slug: arr.attributes.slug.toString()
                    })));
                } else {
                    var index = newArrayKeys.indexOf(key);
                    newArr[index][key].push({
                        month_id: handle_orderMonth(date),
                        date: date,
                        slug: arr.attributes.slug.toString()
                    });
                }
                return (0,_to_consumable_array/* default */.Z)(newArr);
            }, []);
            var sortedRes = res.sort(function(a, b) {
                var indexA = Object.keys(a)[0];
                var indexB = Object.keys(b)[0];
                return indexA - indexB;
            }).reverse();
            return res.map(function(item) {
                var key = Object.keys(item)[0]; // get the key (year) of the item
                var sortedValues = item[key].sort(function(a, b) {
                    return a.month_id - b.month_id;
                }); // sort the values by month_id
                return (0,_define_property/* default */.Z)({}, key, sortedValues); // return the sorted item
            });
        }
    }), archiveList = ref2.data, isLoading = ref2.isLoading, isError = ref2.isError;
    var ref3 = (0,react.useState)(query === null || query === void 0 ? void 0 : (ref = query.archive) === null || ref === void 0 ? void 0 : ref.split("-")[1]), expanded = ref3[0], setExpanded = ref3[1];
    var handleChange = function(panel) {
        return function(event, isExpanded) {
            setExpanded(isExpanded ? panel : false);
        };
    };
    if (isLoading) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                animation: "wave"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                animation: "wave"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                animation: "wave"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
                animation: "wave"
            })
        ]
    });
    if (isError) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: "...error"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(News_styles/* Aside */.xN, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "archive",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                            className: "title",
                            children: t(title)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "".concat(url),
                            locale: locale,
                            shallow: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    className: "seeAll",
                                    children: t("seeAll")
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    children: archiveList.map(function(item) {
                        var title = Object.keys(item)[0];
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.Z, {
                            expanded: expanded === title,
                            onChange: handleChange(title),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSummary/* default */.Z, {
                                    "aria-controls": "panel1bh-content",
                                    id: "panel1bh-header",
                                    expandIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M17 10L12 15L7 10",
                                            stroke: "#737373",
                                            strokeWidth: "1",
                                            strokeLinecap: "round"
                                        })
                                    }),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionDetails/* default */.Z, {
                                    children: item[title].map(function(param) {
                                        var date = param.date, slug = param.slug;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "".concat(url, "?archive=").concat(slug),
                                            locale: locale,
                                            shallow: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        children: date
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                                                        children: locale === "fa" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconsSvg/* ArrowLeft */.Xd, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconsSvg/* ArrowRight */.ol, {})
                                                    })
                                                ]
                                            })
                                        }, slug);
                                    })
                                })
                            ]
                        }, title);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/NTContainer.jsx



function NTContainer(param) {
    var children = param.children;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: (0,_define_property/* default */.Z)({
            mb: "140px",
            pt: "80px"
        }, theme.breakpoints.down("md"), {
            p: 0,
            mb: 0
        }),
        children: children
    });
};

// EXTERNAL MODULE: ./components/EndDateStamp.jsx
var EndDateStamp = __webpack_require__(38692);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/TendersItems.jsx








function TendersItems(post) {
    var ref;
    var t = (0,esm/* useTranslation */.$G)([
        "article"
    ]).t;
    var id = post.id, _attributes = post.attributes, title = _attributes.title, slug = _attributes.slug, thumbnail = _attributes.thumbnail, short_description = _attributes.short_description, datetime = _attributes.datetime, end_datetime = _attributes.end_datetime, type = _attributes.type;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(News_styles/* ArticleItem */.oF, {
        type: type,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "imageWrapper",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "overlay",
                        children: type === "tender" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: t("tender.tender")
                        }) : type === "auction" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: t("tender.auction")
                        })
                    }),
                    !!thumbnail.data && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextImage/* default */.Z, {
                        layout: "responsive",
                        width: 180,
                        height: 150,
                        objectFit: "cover",
                        src: (ref = thumbnail.data) === null || ref === void 0 ? void 0 : ref.attributes.formats.thumbnail.url,
                        alt: title,
                        placeholder: "blur"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "contentWrapper",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeadTitle, {
                        as: "h2",
                        url: "/suppliers/tenders-auctions/".concat(id, "/").concat(slug),
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        className: "text",
                        children: (0,helperFunction/* truncateString */.aS)(short_description, 135)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "articleItemFooter",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateStamp/* default */.Z, {
                                date: datetime,
                                time: false
                            }),
                            !!end_datetime && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EndDateStamp/* default */.Z, {
                                date: end_datetime
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/GalleryLightBox.jsx + 44 modules
var GalleryLightBox = __webpack_require__(69359);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/GallerySection.jsx






function GallerySection(param) {
    var images = param.images;
    var ref = (0,react.useState)(-1), index = ref[0], setIndex = ref[1];
    var handle_renderThumbnail = function(item) {
        if (item.mime.includes("video")) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "videoThumb",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "playIcon"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("video", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                            src: "".concat("https://websiteapidev.aryasasol.com").concat(item.url),
                            type: "video/mp4"
                        })
                    })
                ]
            });
        } else {
            var image = (0,helperFunction/* getImageUrl */.Jn)(item.formats, "medium");
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "imageThumb",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextImage/* default */.Z, {
                    layout: "responsive",
                    objectFit: "cover",
                    src: image === null || image === void 0 ? void 0 : image.url,
                    alt: item.caption,
                    width: 283,
                    height: 190,
                    placeholder: "blur"
                })
            });
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Layout_styles/* GalleryWrapper */.Xu, {
        children: [
            images.map(function(item, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    onClick: function() {
                        return setIndex(index);
                    },
                    children: handle_renderThumbnail(item.attributes)
                }, item.id);
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GalleryLightBox/* default */.Z, {
                images: images,
                setIndex: setIndex,
                index: index
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/RandomNews.jsx






function RandomNews(param) {
    var news = param.news;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
        container: true,
        columnSpacing: {
            md: 2,
            lg: 5.5
        },
        sx: (0,_define_property/* default */.Z)({
            mb: "100px"
        }, theme.breakpoints.down("md"), {
            px: "16px",
            my: "20px",
            ":not(:last-of-type)": {
                borderBottom: "1px solid #e6e6e7"
            }
        }),
        children: ((news === null || news === void 0 ? void 0 : news.data) || []).map(function(news) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                sx: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
                    ":not(:last-of-type)": {
                        borderBottom: "1px solid #e6e6e7"
                    }
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleItems, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, news), {
                    date: true
                }))
            }, news.id);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/NewsListPageHeader.jsx






function NewsListPageHeader(param) {
    var data = param.data;
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                container: true,
                columnSpacing: {
                    md: 2,
                    lg: 3
                },
                sx: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
                    background: "rgba(242, 242, 243, 0.5)",
                    mb: "40px",
                    px: 0,
                    pb: "20px"
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 8,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("header", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BigNewsSection, (0,_object_spread/* default */.Z)({}, (ref = data === null || data === void 0 ? void 0 : data.pages[0]) === null || ref === void 0 ? void 0 : ref.data[0]))
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 4,
                        sx: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
                            px: "16px"
                        }),
                        children: !(0,helperFunction/* isEmpty */.xb)(data.pages[0].data.slice(1, 7)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AsideNews, {
                            news: data.pages[0].data.slice(1, 7)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {
                variant: "middle",
                sx: (0,_define_property/* default */.Z)({
                    m: "60px 0 80px 0"
                }, theme.breakpoints.down("md"), {
                    display: "none"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/PagesComponents/News&Tender/ShareButton.jsx + 1 modules
var ShareButton = __webpack_require__(13493);
;// CONCATENATED MODULE: ./components/PagesComponents/News&Tender/index.jsx












/***/ })

}]);